/**
 * @generated SignedSource<<31f857ec2063fa7a92783d15542e9559>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type linkStoryStyleCardLinkArticle$data = {
  readonly urlAlias: string;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "linkStoryStyleCardLinkArticle";
};
export type linkStoryStyleCardLinkArticle$key = {
  readonly " $data"?: linkStoryStyleCardLinkArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"linkStoryStyleCardLinkArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "linkStoryStyleCardLinkArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "9c0884d3add52bf5136c8a2664af4ded";

export default node;
